import React, { useState } from "react";
import Box from "@mui/material/Box";
import {
  DataGrid,
  gridClasses,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import axios from "axios";
import { Button, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import Modal from "@mui/material/Modal";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { Popper, ClickAwayListener } from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const TenderTable = ({ tenders, activeTab, isLoading }) => {
  const navigate = useNavigate();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [status, setStatus] = useState();
  const [reason, setReason] = useState("");
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openReworkModal, setOpenReworkModal] = useState(false);
  const [tenderId, setTenderId] = useState();
  const [tenderReworkNumber, setTenderReworkNumber] = useState();

  const handleOpen = (s) => {
    setOpen(true);
    setStatus(s);
  };
  const handleClose = () => {
    setOpen(false);
    setStatus("");
    setReason("");
    setOpenReworkModal(false);
  };

  const handleTenderUpdate = async (id, status) => {
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/tender`,
        {
          tenderId: id,
          status: status,
          reason: reason,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      navigate("/dashboard");
    } catch (error) {
      console.log(error);
    }
  };

  const handleCheck = (tenderId) => {
    navigate(`/dashboard/${tenderId}`);
    localStorage.setItem("activeTab", activeTab)
  };

  const handleReviewVendorBtn = (tenderId) => {
    localStorage.setItem("tab", "VQ");
    navigate(`/dashboard/${tenderId}`);
  };

  const columns = [
    // { field: "tenderId", headerName: "Tender ID", width: 200, headerAlign: "center", },
    {
      field: "title",
      headerName: "Title",
      flex: 1,
      renderCell: (params) => (
        <span
          className="table-title"
          onClick={() => handleCheck(params.row.tenderId)}
        >
          {params.row.title}
        </span>
      ),
    },
    {
      field: "type",
      headerName: "Tender Type",
      flex: 1,
      renderCell: (params) =>
        params.row.type
          ? params.row.type.charAt(0).toUpperCase() +
            params.row.type.slice(1).toLowerCase()
          : "",
    },
    {
      field: "tenderPublishDate",
      headerName: "Tender Publish Date",
      flex: 1,
    },
    {
      field: "bidSubmissionEndDate",
      headerName: "Bid Close Date",
      flex: 1,
    },
    {
      field: "status",
      headerName: "Tender Status",
      flex: 1,
      renderCell: (params) => {
        const statusColors = {
          REVIEW: "#FFCD82",
          UPCOMING: "#54A7FF",
          REJECTED: "#FA6459",
          REWORK: "#EA981F",
          ACCEPTING_BIDS: "#009688",
          BIDS_CLOSED: "#BEB3B3",
          REBIDDING: "#FF9800",
          AWARDED: "#0381F3",
          DISCARDED: "#CB856B",
        };
        return (
          <>
            {(storedUser.userRole[0] === "TECHNICAL_HEAD" ||
              storedUser.userRole[0] === "PURCHASE_HEAD") &&
            activeTab === "VENDOR" ? (
              <span
                style={{
                  background: "#B7D400",
                  borderRadius: "15px",
                  padding: "5px 15px",
                  fontWeight: 600,
                }}
              >
                Vendor Qualification
              </span>
            ) : (
              <span
                style={{
                  background: statusColors[params.row.status],
                  borderRadius: "15px",
                  padding: "5px 15px",
                  fontWeight: 600,
                }}
              >
                {params.row.status ? params.row.status.replace("_", " ") : ""}
              </span>
            )}
          </>
        );
      },
    },
    storedUser.userRole[0] === "BUYER" &&
      activeTab === "REWORK" && {
        field: "action",
        headerName: "Action",
        flex: 1,
        renderCell: (params) => {
          const handleClick = (event) => {
            setAnchorEl(event.currentTarget);
            setSelectedRow(params.row); // save current row
          };

          const handleClose = () => {
            setAnchorEl(null);
          };

          const handleOpenModal = () => {
            setAnchorEl(null);
            setOpenReworkModal(true);
            if (selectedRow) {
              setTenderId(selectedRow.tenderId);
              setTenderReworkNumber(selectedRow.tenderReworkNumber);
            }
          };

          const openEdit = Boolean(anchorEl);

          return (
            <div style={{ position: "relative", display: "inline-block" }}>
              <span
                onClick={handleClick}
                style={{ cursor: "pointer", fontWeight: 600 }}
              >
                Edit
              </span>

              <Popper
                open={openEdit && selectedRow?.tenderId === params.row.tenderId}
                anchorEl={anchorEl}
                placement="bottom"
                className="popper"
                modifiers={[
                  {
                    name: "offset",
                    options: {
                      offset: [0, 10],
                    },
                  },
                ]}
                style={{ zIndex: 1300 }}
              >
                <ClickAwayListener onClickAway={handleClose}>
                  <div style={{ position: "relative" }}>
                    {/* Triangle */}
                    <div
                      style={{
                        position: "absolute",
                        top: -21,
                        right: 30,
                      }}
                    >
                      <PlayArrowIcon
                        fontSize="large"
                        style={{ rotate: "-90deg", color: "#D8E9F0" }}
                      />
                    </div>

                    {/* Menu Items */}
                    <div className="menu">
                      <Link
                        to={`/dashboard/edit-approver/${params.row.tenderId}`}
                        onClick={() => localStorage.setItem("activeTab", "REWORK")}
                      >
                        <div className="menu-item" onClick={handleClose}>
                          Edit Approvers
                        </div>
                      </Link>
                      <div className="menu-item" onClick={handleOpenModal}>
                        Edit Tender Details
                      </div>
                    </div>
                  </div>
                </ClickAwayListener>
              </Popper>
            </div>
          );
        },
      },
    (storedUser.userRole[0] === "TECHNICAL_HEAD" ||
      storedUser.userRole[0] === "PURCHASE_HEAD") &&
      activeTab === "VENDOR" && {
        field: "action",
        headerName: "Action",
        flex: 1,
        renderCell: (params) => (
          <div style={{ display: "inline-flex", gap: 6 }}>
            <Button
              className="btn-contained"
              sx={{
                margin: "0 !important",
                fontSize: "12px",
                px: 9,
                width: "0 !important",
              }}
              onClick={() => handleReviewVendorBtn(params.row.tenderId)}
            >
              Review Vendors
            </Button>
          </div>
        ),
      },
    storedUser.userRole[0] === "PURCHASE_HEAD" &&
      activeTab !== "VENDOR" && {
        field: "action",
        headerName: "Action",
        flex: 1,
        renderCell: (params) => (
          <div style={{ display: "inline-flex", gap: 6 }}>
            <Link to={`/dashboard/tender/${params.row.tenderId}`}>View</Link>
          </div>
        ),
      },
    storedUser.userRole[0] === "FINANCE_HEAD" &&
      activeTab !== "VENDOR" && {
        field: "action",
        headerName: "Action",
        flex: 1,
        renderCell: (params) => (
          <div style={{ display: "inline-flex", gap: 6 }}>
            <Button
              className="btn-contained"
              sx={{
                margin: "0 !important",
                fontSize: "12px",
                px: 9,
                width: "0 !important",
              }}
              onClick={() => handleReviewVendorBtn(params.row.tenderId)}
            >
              Verify EMD/CMD
            </Button>
          </div>
        ),
      },
  ].filter(Boolean);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const [date, time] = dateString.split("T");
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year} ${time}`;
  };

  const rows =
    tenders &&
    tenders.map((tender) => ({
      ...tender,
      tenderPublishDate: formatDate(tender.tenderPublishDate),
      bidSubmissionStartDate: formatDateTime(tender.bidSubmissionStartDate),
      bidSubmissionEndDate: formatDateTime(tender.bidSubmissionEndDate),
    }));

  return (
    <Box sx={{ width: "100%", minHeight: "400px" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        loading={isLoading}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10]}
        disableRowSelectionOnClick
        disableColumnSelector
        disableDensitySelector
        disableColumnMenu
        disableColumnResize
        slots={{ toolbar: CustomToolbar }}
        getRowId={(row) => row.tenderId}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
        }
        sx={{
          position: "relative",
          border: "none",
          fontFamily: "Inter !important",

          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: "700 !important",
          },
          "& .MuiDataGrid-columnHeaders": {
            background: "none !important",
            color: "black",
            fontSize: "14px",
            borderRadius: "10px",
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "#fff",
          },
          "& .MuiDataGrid-cell": {
            fontSize: "13px",
            border: "none",
          },
          "& .MuiDataGrid-columnSeparator": {
            display: "none",
          },
          "& .css-1ccsd5i-MuiButtonBase-root-MuiButton-root": {
            color: "#000 !important",
            border: "1px solid #B0B0B0",
            borderRadius: "12px",
            padding: 1,
          },
          "& .MuiInputBase-root-MuiInput-root::after": {
            borderBottom: "none !important",
          },
          "& .MuiInputBase-root-MuiInput-root": {
            borderBottom: "none !important",
          },
          [`& .${gridClasses.row}.even`]: {
            backgroundColor: "#EAF4FF",
            // '&:hover': {
            //   backgroundColor: "#f6f6f6",
            // },
          },
          "& .MuiInput-underline:before": {
            borderBottom: "none !important",
          },
          "& .css-5h82ro-MuiInputBase-root-MuiInput-root::after": {
            borderBottom: "none !important",
          },
        }}
      />

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Reason for {status}
          </Typography>
          <label htmlFor="reason">Reason</label>
          <textarea
            name="reason"
            id="reason"
            onChange={(e) => setReason(e.target.value)}
            rows={8}
          ></textarea>
          <Box className="btn-container" sx={{ gap: 3, width: "100%" }}>
            <Button
              className="btn-outlined"
              variant="outlined"
              onClick={handleClose}
            >
              Close
            </Button>
            <Button
              className="btn-contained"
              variant="contained"
              onClick={handleTenderUpdate}
            >
              Submit
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Tender ReWork Modal */}
      <Modal
        open={openReworkModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Tender Details can only be edited maximum 3 times. <br />
            This will be your {tenderReworkNumber + 1} out of 3 edits
          </Typography>
          <Box
            className="btn-container"
            sx={{
              width: "100%",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
              <Button className="btn-contained" onClick={() => {
                localStorage.setItem("activeTab", "REWORK")
                navigate(`/dashboard/edit-tender/${tenderId}`)
              }}>Confirm</Button>
            <Button className="btn-outlined btn-reject" onClick={handleClose}>
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default TenderTable;

function CustomToolbar() {
  return (
    <GridToolbarContainer sx={{ display: "flex", justifyContent: "end" }}>
      <GridToolbarQuickFilter
        sx={{
          border: "1px solid #B0B0B0",
          borderRadius: "12px",
          padding: "4px 12px",
          "&:hover": {
            backgroundColor: "#D8E9F0",
          },
          "& .MuiInputBase-root": {
            borderRadius: "12px",
          },
          width: 300,
        }}
      />
      {/* <GridToolbarFilterButton /> */}
    </GridToolbarContainer>
  );
}
